import { TError, TMyFeatureFlag } from '@onesource/schemas';
import { useQuery } from '@tanstack/react-query';

import { getSession } from '../auth';
import axios from '../axios';
import { ENTITY } from './entity';

export const getMyFeatureFlagsQueryKey = () => [ENTITY, 'me'];

/** The current user's feature flags for the members app (global `enabled` + own `assigned`). */
export const useGetMyFeatureFlagsQuery = () => {
  const token = getSession();

  return useQuery<TMyFeatureFlag[], TError>({
    queryKey: getMyFeatureFlagsQueryKey(),
    queryFn: async () => {
      const res = await axios.get<TMyFeatureFlag[]>(`${ENTITY}/me`);
      return res.data;
    },
    enabled: !!token,
    refetchOnWindowFocus: false,
  });
};
